import { actions } from '../../../utils/constants';

export const setGlobalInfo = () => ({
  type: actions.SET_ASYNC_GLOBAL
})

export const setLocalInfo = () => ({
  type: actions.SET_ASYNC_LOCAL
})

export const setCoachesArray = () => ({
  type: actions.SET_ASYNC_COACHES
});

export const AsyncAllInfos = data => ({
  type: actions.SET_ASYNC_SYNC,
  payload: data
})

export const filterSearch = ({ target }) => ({
  type: actions.SET_SEARCH_VALUE,
  payload: target.value
})



// WEBPACK FOOTER //
// ./src/App/containers/statistics/statistics.action.js